import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/oddsButtonBaseball.css';
import {getBBMarketByCode} from '../helpers/marketHelpers';
import {getOddsFromOddsType} from '../../../../../helpers/oddsHelpers';

//actions
import {addOpenBet, removeOpenBet} from '../../../actions/openBetsActions';

import Button from "../../../components/button";

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsList: state.vpp.openBetsList,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage
    };
};

class OddsButtonBaseball extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            openBetsList: storeData.vpp.openBetsList,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                openBetsList: storeData.vpp.openBetsList,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let isChecked = this._isChecked(this.state.openBetsList);

        let isSelected = isChecked
            ? style.selected
            : '';


        let onClick = () => {
            this._enableAnimation();
            !isChecked ? this._placeBet() : this._removeBet();
        };


        let customStyle = this.props.customStyle === undefined ? '' : this.props.customStyle;
        let buttonStyle = this.props.buttonStyle === undefined ? '' : this.props.buttonStyle;
        let isEnabled = this.props.isEnabled === undefined ? true : this.props.isEnabled;
        let disabledStyle = isEnabled
            ? ''
            : style.disabled;

        let odd = this.props.market === undefined ? '' : getOddsFromOddsType(this.props.market.odds, this.state.selectedOddsType);
        let emptyRow = this.props.market === 'empty';


        return (
            <Fragment>
                {!emptyRow &&
                    <Button
                        style={`${style.oddsButton} ${customStyle} ${disabledStyle}`}
                        sbLabel={odd}
                        sbSub={''}
                        isChecked={isChecked}
                        circleSize={this.props.circleSize}
                        isEnabled={isEnabled}
                        buttonStyle={buttonStyle}
                        buttonWrapperStyle={`${style.oddsButtonCustom}`}
                        callback={() => onClick()}
                        reference={this.props.reference}/>
                }
            </Fragment>
        );
    }

    _placeBet() {
        if (this.props.active === true) {
            let bet = {
                game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                event: this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex],
                betType: getBBMarketByCode(this.props.market.code),
                market: this.props.market
            };
            this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsList));
        }
    }

    _removeBet() {
        if (this.props.active === true) {
            this.props.store.dispatch(removeOpenBet(this.bet));
        }
    }

    _enableAnimation() {
    }

    _isChecked(openBetsList) {
        if (openBetsList.length > 0) {
            let currentSelectedGame = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex];
            let currentSelectedEvent = this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex];
            for (let i = 0; i < openBetsList.length; i++) {
                if (openBetsList[i].bets[0].game.channel === currentSelectedGame.channel && openBetsList[i].bets[0].event.eventId === currentSelectedEvent.eventId && openBetsList[i].bets[0].market.id === this.props.market.id) {
                    this.bet = openBetsList[i];
                    return true;
                }
            }
        }
        return false;
    }

}

export default connect(mapStateToProps)(OddsButtonBaseball);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/oddsButtonBaseball.js